import { batch } from 'react-redux'
import { Clear as ClearIcon } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useAppDispatch } from 'app/hooks'
import { useSelector } from 'react-redux'
import { selectIsFiltered } from 'app/selectors'
import { clearFilters } from 'app/thunks'
import { useHistory } from 'react-router'
import { getSelectBaseUri } from 'app/selectors'


const ClearButton = () => {
  const dispatch = useAppDispatch()
  const history = useHistory();
  const isFiltered = useSelector(selectIsFiltered)
  const baseUri = useSelector(getSelectBaseUri());
  return isFiltered ? (
    <Button
      onClick={(e) => {
        batch(() => {
          history.push(baseUri)
          dispatch(clearFilters())
        })
      }}
      variant="contained"
      disabled={!isFiltered}
      startIcon={<ClearIcon />}
    >
      Clear All
    </Button>
  ) : <></>
}

export default ClearButton
